import RoomState from "./RoomState";
import Room from "./Room";

export default class StorylineState {
    constructor(storyline) {
        this.storyline = storyline;
        this.roomState = null;
    }

    start() {
        console.log("START");
        console.log(this.tutorialRoom);
        this.roomState = new RoomState(this.tutorialRoom);
    }

    get currentRoomId() {
        return this.roomState.room.id;
    }

    get tutorialRoomId() {
        return this.storyline.tutorial_room_id;
    }

    get tutorialRoom() {
        let tutorialRooms = this.rooms.filter((room) => room.id === this.tutorialRoomId);
        if ( !tutorialRooms || tutorialRooms.length <= 0 )
            return null;

        return tutorialRooms[0];
    }

    get startingRoomId() {
        return this.storyline.starting_room_id;
    }

    get startingRoom() {
        let startingRooms = this.rooms.filter((room) => room.id === this.startingRoomId);
        if ( !startingRooms || startingRooms.length <= 0 )
            return null;

        return startingRooms[0];
    }

    getStorylineRoom(roomId) {
        let startingRooms = this.rooms.filter((room) => room.id === roomId);
        if ( !startingRooms || startingRooms.length <= 0 )
            return null;

        return startingRooms[0];
    }
    
    get rooms() {
        if ( typeof this.storyline.rooms === "undefined" || this.storyline.rooms.length <= 0 ) {
            return null;
        }

        return this.storyline.rooms.map((room) => Room.fromObj(room));
        // return this.storyline.rooms;
    }

    get hasRoomLoaded() {
        return (typeof this.roomState !== "undefined") && this.roomState !== null;
    }

}
